import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { COLLABORATOR_I18N_KEY } from "./constants";
var pt = /*#__PURE__*/_defineProperty({}, COLLABORATOR_I18N_KEY, {
  KH_CLOSE: 'Fechar',
  KH_LAST_UPDATED: 'Atualizado em: {{date}}',
  KH_MODULES: 'Módulos',
  KH_RATING: 'Avaliação',
  KH_STUDENTS: 'Alunos',
  KH_COURSE_SEE_DETAIL: 'Ver detalhes',
  KH_SEE_CATALOG: 'Ver catálogo',
  KH_SEARCH: 'Procurar',
  KH_FILTER_CATEGORY_ALL: 'Todos',
  KH_SEARCH_SUCCESS_RESULTS: 'Resultados da sua pesquisa',
  KN_DOCUMENT: 'Documento',
  KN_DOWNLOAD: 'Download',
  KH_SEARCH_NO_RESULTS: 'Nenhum resultado encontrado',
  KH_SEARCH_X_RESULTS: '{{count}} resultado',
  KH_SEARCH_X_RESULTS_plural: '{{count}} resultados',
  KH_SEARCH_NO_RESULTS_FOR: 'Nenhum resultado encontrado para "{{query}}"',
  KH_SEARCH_NO_RESULTS_ACTION: 'Tente outra palavra',
  KH_COURSE_ENROLL: 'Inscrever-se',
  KH_SEARCH_PLACEHOLDER: 'O que você quer procurar?',
  KH_SEARCH_PLACEHOLDER_SHORT: 'O que você procura?',
  KH_SEARCH_CLEAR: 'Limpar pesquisa',
  KH_FILTER_TITLE: 'Filtros',
  KH_FILTER_CTA: 'Filtrar',
  KH_FILTER_ITEM_CATEGORIES: 'Categorias',
  KH_FILTER_ITEM_PROVIDER: 'Aliados',
  KH_FILTER_ITEM_LEVELS: 'Níveis',
  KH_FILTER_ITEM_LANGUAGES: 'Idiomas',
  KH_FILTER_ITEM_CONTENT_TYPES: 'Tipo de conteúdo',
  KH_FILTER_INITIAL_CTA: 'Filtrar por',
  KH_FILTER_VIEW_ALL: 'Ver tudo',
  KH_COURSES: 'Cursos',
  KH_COURSE: 'Curso',
  KH_BREADCRUMB_HOME: 'Começar',
  KH_BREADCRUMB_CATALOG: 'Catálogo',
  KH_BREADCRUMB_INTEREST_CONTENT: 'Conteúdo de seu interesse',
  KH_BREADCRUMB_ONLY: 'Conteúdo de {{name}}',
  KH_BREADCRUMB_THIRD_PARTY_CONTENT: 'Conteúdos externos',
  KH_COME_BACK: 'Voltar',
  KH_ERROR_VIEW_MESSAGE: 'Ups! Algo deu errado. Por favor, recarregue a página. Se o problema persistir, entre em contato com o suporte.',
  KH_ERROR_VIEW_SHOW_ERROR: 'Mostrar erro',
  KH_ERROR_VIEW_HIDE_ERROR: 'Ocultar erro',
  KH_ERROR_VIEW_TRY_AGAIN: 'Recarregar página',
  KH_NO_DATA_LOADED_ERROR_MESSAGE: 'Lamentamos, mas não foram encontradas categorias ou cursos disponíveis. Isto pode dever-se ao facto de as categorias não terem sido carregadas corretamente ou não conterem cursos. Contacte o administrador da plataforma para resolver o problema.',
  KH_CONTENT_OF_INTEREST_TITLE: 'Conteúdo de seu interesse',
  KH_THIRD_PARTY_CONTENT_TITLE: 'Conteúdos externos',
  KH_COURSES_DYNAMIC: '{{count}} curso',
  KH_COURSES_DYNAMIC_plural: '{{count}} cursos',
  KH_TEXT_TRACK: 'Rota'
});
export default pt;